<template>
	<div class="home">
		<img class="logo-cpe" src="@/assets/img/splash_screen/CPE.png" alt="CPE">
		<estrella v-for="(i, index) in 5" :key="`fija-${index}`"></estrella>
		<estrella-fugaz v-for="(i, index) in 3" :key="`fugaz-${index}`"></estrella-fugaz>
		<ovni></ovni>
		<div class="container-planet">
			<marte @marte-click="irAEstudiantes"></marte>
			<saturno @saturno-click="irADocentes"></saturno>
		</div>
		<div class="container-planet">
			<planeta-presidencia @presidencia-click="irAPresidencia"></planeta-presidencia>			
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import marte from "@/components/Marte.vue";
import saturno from "@/components/Saturno.vue";
import PlanetaPresidencia from "@/components/PlanetaPresidencia.vue";
import Estrella from "@/components/Estrella.vue";
import EstrellaFugaz from "@/components/EstrellaFugaz.vue";
import Ovni from "@/components/Ovni.vue";

export default {
	name: "home",
	components: {
		marte,
		saturno,
		Estrella,
		EstrellaFugaz,
		Ovni,
		PlanetaPresidencia
	},
	data: function() {
		return { };
	},
	computed: {},
	methods: {
		irADocentes() {
			console.log("Docentes");
			this.$router.push({ name: "docentes" });
		},
		irAEstudiantes() {
			console.log("Estudiantes");
			this.$router.push({ name: "estudiantes" });
		},
		irAPresidencia(){
			this.$router.push({ name: "presidencia" });
		}
	}
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/responsiveness.scss";
.home {
	box-sizing: border-box;
	padding-top: 40px;
	padding-bottom: 10px;
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-image: url("~@/assets/img/home_screen/Background.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	@include mobile {
		flex-direction: column;
		justify-content: center;
	}
}

.container-planet{
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	// overflow: hidden;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	@include mobile {
		height: auto;
		flex-direction: column;
		justify-content: space-around;
	}
}

.logo-cpe {
	position: fixed;
	right: 15px;
	bottom: 15px;
	width: 200px;
	max-width: 30%;
	opacity: 0.5;
	@include mobile {
		right: unset;
		left: 15px;
	}
}
</style>

